import React, { FC } from 'react';
import styles from './PageContainer.module.scss';

interface PageContainerProps {
	children: JSX.Element | JSX.Element[];
}

const PageContainer: FC<PageContainerProps> = ({ children }): JSX.Element => {
	return <section className={styles.PageContainer}>{children}</section>;
};

export { PageContainer };
